import {EnvironmentCabinet} from 'compob2b-libs';

export class EnvironmentCabinetProd extends EnvironmentCabinet {
  production = true;
  // SW выпилен из контура витрины: свежесть статики держат content-hashed
  // бандлы + cache-заголовки nginx, не Service Worker. false → register(enabled:false)
  // + swUpdate.isEnabled=false (ракета-тост гаснет сам). Кабинет (environment.prod.ts)
  // остаётся true. См. docs/showcase-build-topology.md «Кэш и доставка статики».
  serviceWorkers = false;
  serverApi = 'https://show.dtm.ru/api/v1';
  serverPicturesPath = 'https://show.dtm.ru/pictures';
  serverDocumentsPath = 'https://show.dtm.ru/documents';
  // Хост витрины. Сравнивается на СТРОГОЕ равенство с текущим host'ом —
  // им гейтится showcase-режим. Неверное значение молча выключает контур,
  // без ошибки в консоли. Менять только вместе с nginx-vhost и плейбуком.
  showcaseUrl = 'show.dtm.ru';
  aiTranslation = false;
}

export const environment = new EnvironmentCabinetProd();
